// extracted by mini-css-extract-plugin
export default {"cogs":"Home_cogs__k59bx","spinnerContainer":"Home_spinnerContainer__F+PMc"};